import { render, staticRenderFns } from "./PreviousBackups.vue?vue&type=template&id=c5f7d11c"
import script from "./PreviousBackups.vue?vue&type=script&lang=ts"
export * from "./PreviousBackups.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c5f7d11c')) {
      api.createRecord('c5f7d11c', component.options)
    } else {
      api.reload('c5f7d11c', component.options)
    }
    module.hot.accept("./PreviousBackups.vue?vue&type=template&id=c5f7d11c", function () {
      api.rerender('c5f7d11c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-default/PreviousBackups.vue"
export default component.exports